import { render, staticRenderFns } from "./CSVUploadFeedbackModal.vue?vue&type=template&id=3660224c&"
import script from "./CSVUploadFeedbackModal.vue?vue&type=script&lang=ts&"
export * from "./CSVUploadFeedbackModal.vue?vue&type=script&lang=ts&"
import style0 from "./CSVUploadFeedbackModal.vue?vue&type=style&index=0&id=3660224c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports